import { QuizQuestion } from '../types';

// Quick quiz for fast recommendations (7 questions)
export const quickQuizQuestions: QuizQuestion[] = [
  {
    id: 'primary_genre',
    question: 'What kind of book are you in the mood for?',
    options: [
      { id: 'contemporary', text: '📚 Contemporary Fiction', value: 'contemporary fiction' },
      { id: 'fantasy', text: '🔮 Fantasy', value: 'fantasy' },
      { id: 'mystery', text: '🔍 Mystery/Thriller', value: 'mystery thriller' },
      { id: 'horror', text: '👻 Horror', value: 'horror' },
      { id: 'scifi', text: '🚀 Science Fiction', value: 'science fiction' },
      { id: 'literary', text: '✍️ Literary Fiction', value: 'literary fiction' },
      { id: 'romance', text: '❤️ Romance', value: 'romance' },
      { id: 'historical', text: '📜 Historical Fiction', value: 'historical fiction' },
      { id: 'nonfiction', text: '📖 Narrative Non-Fiction', value: 'narrative non-fiction' }
    ]
  },
  {
    id: 'reading_mood',
    question: 'What\'s your current reading mood?',
    options: [
      { id: 'escape', text: '🌈 Escape from Reality', value: 'escape' },
      { id: 'learn', text: '🎓 Learn Something New', value: 'learn' },
      { id: 'feel', text: '💭 Feel Deep Emotions', value: 'feel' },
      { id: 'thrill', text: '⚡ Get Thrilled', value: 'thrill' }
    ]
  },
  {
    id: 'reading_pace',
    question: 'How would you like the story to unfold?',
    options: [
      { id: 'fast', text: '⚡ Fast-paced & Action-packed', value: 'fast paced action' },
      { id: 'balanced', text: '⚖️ Balanced Plot & Character', value: 'balanced' },
      { id: 'character', text: '👤 Character-focused & Deep', value: 'character driven' }
    ]
  },
  {
    id: 'emotional_tone',
    question: 'What emotional experience are you seeking?',
    options: [
      { id: 'uplifting', text: '✨ Uplifting & Hopeful', value: 'uplifting' },
      { id: 'intense', text: '🌋 Intense & Dramatic', value: 'intense' },
      { id: 'thoughtful', text: '🤔 Thought-provoking', value: 'thoughtful' },
      { id: 'dark', text: '🌑 Dark & Atmospheric', value: 'dark' },
      { id: 'humorous', text: '😄 Funny & Light-hearted', value: 'humorous' }
    ]
  },
  {
    id: 'reading_time',
    question: 'When do you usually read?',
    options: [
      { id: 'bedtime', text: '🌙 Before Bed', value: 'bedtime' },
      { id: 'commute', text: '🚌 During Commute', value: 'commute' },
      { id: 'weekend', text: '☀️ Weekend Reading', value: 'weekend' },
      { id: 'anytime', text: '⏰ Whenever I Can', value: 'anytime' }
    ]
  },
  {
    id: 'themes',
    question: 'Which theme interests you most?',
    options: [
      { id: 'adventure', text: '🗺️ Adventure & Discovery', value: 'adventure' },
      { id: 'relationships', text: '💝 Love & Connection', value: 'relationships' },
      { id: 'growth', text: '🌱 Personal Growth', value: 'growth' },
      { id: 'social', text: '🌍 Social Issues', value: 'social' },
      { id: 'cultural', text: '🎭 Cultural Identity', value: 'cultural' },
      { id: 'historical', text: '📜 Historical Events', value: 'historical' }
    ]
  },
  {
    id: 'content_preference',
    question: 'What content level are you comfortable with?',
    options: [
      { id: 'light', text: '🌟 Light & Clean', value: 'light' },
      { id: 'moderate', text: '🌓 Moderate Content', value: 'moderate' },
      { id: 'mature', text: '🌑 Mature Themes', value: 'mature' }
    ]
  }
];

// Comprehensive quiz for detailed recommendations (12 questions)
export const comprehensiveQuizQuestions: QuizQuestion[] = [
  {
    id: 'primary_genre',
    question: 'What\'s your primary genre preference?',
    options: [
      { id: 'contemporary', text: '📚 Contemporary Fiction', value: 'contemporary fiction' },
      { id: 'fantasy', text: '🔮 Fantasy', value: 'fantasy' },
      { id: 'mystery', text: '🔍 Mystery/Thriller', value: 'mystery thriller' },
      { id: 'horror', text: '👻 Horror', value: 'horror' },
      { id: 'scifi', text: '🚀 Science Fiction', value: 'science fiction' },
      { id: 'literary', text: '✍️ Literary Fiction', value: 'literary fiction' },
      { id: 'romance', text: '❤️ Romance', value: 'romance' },
      { id: 'historical', text: '📜 Historical Fiction', value: 'historical fiction' },
      { id: 'nonfiction', text: '📖 Narrative Non-Fiction', value: 'narrative non-fiction' }
    ]
  },
  {
    id: 'secondary_genre',
    question: 'What elements would you like mixed in?',
    options: [
      { id: 'adventure', text: '🗺️ Adventure', value: 'adventure' },
      { id: 'mystery', text: '🔍 Mystery', value: 'mystery' },
      { id: 'romance', text: '❤️ Romance', value: 'romance' },
      { id: 'supernatural', text: '👻 Supernatural', value: 'supernatural' },
      { id: 'historical', text: '📜 Historical', value: 'historical' },
      { id: 'cultural', text: '🎭 Cultural', value: 'cultural' }
    ]
  },
  {
    id: 'reading_mood',
    question: 'What\'s your current reading mood?',
    options: [
      { id: 'escape', text: '🌈 Escape from Reality', value: 'escape' },
      { id: 'learn', text: '🎓 Learn Something New', value: 'learn' },
      { id: 'feel', text: '💭 Feel Deep Emotions', value: 'feel' },
      { id: 'thrill', text: '⚡ Get Thrilled', value: 'thrill' }
    ]
  },
  {
    id: 'writing_style',
    question: 'What writing style do you prefer?',
    options: [
      { id: 'descriptive', text: '🎨 Rich & Descriptive', value: 'descriptive' },
      { id: 'direct', text: '⚡ Concise & Direct', value: 'direct' },
      { id: 'poetic', text: '🎭 Lyrical & Poetic', value: 'poetic' },
      { id: 'conversational', text: '💭 Conversational', value: 'conversational' }
    ]
  },
  {
    id: 'reading_environment',
    question: 'Where do you usually read?',
    options: [
      { id: 'home', text: '🏠 Cozy at Home', value: 'home' },
      { id: 'commute', text: '🚌 On the Go', value: 'commute' },
      { id: 'outdoors', text: '🌳 Outdoors', value: 'outdoors' },
      { id: 'cafe', text: '☕ At a Café', value: 'cafe' }
    ]
  },
  {
    id: 'pacing',
    question: 'What reading pace do you enjoy?',
    options: [
      { id: 'fast', text: '⚡ Fast & Gripping', value: 'fast' },
      { id: 'moderate', text: '⚖️ Balanced', value: 'moderate' },
      { id: 'slow', text: '🌿 Slow & Detailed', value: 'slow' }
    ]
  },
  {
    id: 'themes',
    question: 'Which themes resonate with you most?',
    options: [
      { id: 'identity', text: '🎭 Identity & Self-discovery', value: 'identity' },
      { id: 'relationships', text: '❤️ Love & Relationships', value: 'relationships' },
      { id: 'power', text: '👑 Power & Politics', value: 'power' },
      { id: 'society', text: '🌍 Social Issues', value: 'society' },
      { id: 'family', text: '👨‍👩‍👧‍👦 Family Dynamics', value: 'family' },
      { id: 'cultural', text: '🎭 Cultural Heritage', value: 'cultural' }
    ]
  },
  {
    id: 'emotional_impact',
    question: 'What emotional impact are you looking for?',
    options: [
      { id: 'uplifting', text: '✨ Uplifting & Inspiring', value: 'uplifting' },
      { id: 'emotional', text: '💭 Deep & Moving', value: 'emotional' },
      { id: 'thrilling', text: '⚡ Exciting & Intense', value: 'thrilling' },
      { id: 'dark', text: '🌑 Dark & Atmospheric', value: 'dark' },
      { id: 'humorous', text: '😄 Funny & Light', value: 'humorous' }
    ]
  },
  {
    id: 'complexity',
    question: 'How complex should the plot be?',
    options: [
      { id: 'simple', text: '🎯 Single Clear Plot', value: 'simple' },
      { id: 'moderate', text: '🔄 Multiple Threads', value: 'moderate' },
      { id: 'complex', text: '🕸️ Complex & Layered', value: 'complex' }
    ]
  },
  {
    id: 'length',
    question: 'What\'s your preferred book length?',
    options: [
      { id: 'short', text: '📱 Under 300 pages', value: 'short' },
      { id: 'medium', text: '📖 300-500 pages', value: 'medium' },
      { id: 'long', text: '📚 Over 500 pages', value: 'long' }
    ]
  },
  {
    id: 'content_rating',
    question: 'What content level are you comfortable with?',
    options: [
      { id: 'clean', text: '🌟 Clean/Mild', value: 'clean' },
      { id: 'moderate', text: '🌓 Moderate', value: 'moderate' },
      { id: 'mature', text: '🌑 Mature Themes', value: 'mature' }
    ]
  },
  {
    id: 'perspective',
    question: 'Which narrative perspective do you prefer?',
    options: [
      { id: 'first', text: '👤 First Person', value: 'first' },
      { id: 'third', text: '👥 Third Person', value: 'third' },
      { id: 'multiple', text: '🎭 Multiple POVs', value: 'multiple' }
    ]
  }
];